import { MDBSpinner } from "mdb-react-ui-kit";
import Select from "react-select";
import ApiService from "../../Core/Service/ApiService";
import { useEffect, useState } from "react";

const CategorySelect = (props) => {
    const {data, setData, hideSubCategory} = props;
    const [topCategories, setTopCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [loadingSubCategories, setLoadingSubCategories] = useState(false);

    useEffect(() => {
        ApiService.get('/categories').then(response=> {
            setTopCategories(response.data.categories?.map(c=>({
                value: c.category_id,
                label: c.category_name
            })));
        })
    }, []);

    useEffect(() => {
        if(data.top_cat_id) {
            setLoadingSubCategories(true);

            ApiService.get('/categories', {parent_id: data.top_cat_id}).then(response=>{
                setSubCategories([
                    {value: '0', label: '- None -'},
                    ...response.data.categories?.map(c=>({
                        value: c.category_id,
                        label: c.category_name
                    }))
                ]);
            })
            .finally(() =>{
                setLoadingSubCategories(false);
            });
        }
    }, [data.top_cat_id]);

    const handleTopCategoryChange = (opt) => {
        setData({
            top_cat_id: opt.value,
            sub_cat_id: 0
        })
    }
    const handleSubCategoryChange = (opt) => {
        setData({
            ...data,
            sub_cat_id: opt.value
        })
    }

    return (
    <div className="category-select d-flex align-items-center">
        <div>
            <label>Top Category:</label>
            <div style={{width: 300}}>
                <Select 
                    options={topCategories} 
                    value={topCategories?.find(c=>c.value == data.top_cat_id)} 
                    onChange={handleTopCategoryChange}
                />
            </div>
        </div>
        {!hideSubCategory && <div className="ms-4">
            <label>Sub Category:</label>
            <div className="d-flex align-items-center">
                <div style={{width: 300}}>
                    <Select
                        options={subCategories}
                        value={subCategories?.find(c=>c.value == data.sub_cat_id)}
                        onChange={handleSubCategoryChange}
                    />
                </div>
                { loadingSubCategories && <MDBSpinner className="ms-2" /> }
            </div>
        </div>}
    </div>
    )
}

export default CategorySelect;